import { Button, Dialog, Radio } from "@material-ui/core";
import styles from "./AddNewCatalog.module.scss";
import Clear from "@material-ui/icons/Clear";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import { withTranslation } from "react-i18next";

const StyledDialog = withStyles({
  paper: {
    width: 600,
    maxWidth: 600,
  },
})(Dialog);
const StyledFormControl = withStyles({
  root: {
    display: "inline",
  },
})(FormControl);
const StyledRadio = withStyles({
  root: {
    color: "#102b4e",
    "&$checked": {
      color: "#102b4e",
    },
  },
  checked: {},
})(Radio);

class AddNewCatalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      catalogId: "",
      model: "",
      modelYear: "",
      vehicleType: "",
      isModelE: "",
      enableAccessories: "",
      factNumber: "",
      buttonDisabled: true,
    };
  }

  handleClose = () => {
    this.props.closeModal();
    this.setState({
      catalogId: "",
      model: "",
      modelYear: "",
      vehicleType: "",
      isModelE: "",
      enableAccessories: "",
      factNumber: "",
      buttonDisabled: true,
    });
  };

  handleCatalogId = (event) => {
    this.setState({ catalogId: event.target.value }, this.disableCheck);
  };
  handleModel = (event) => {
    this.setState({ model: event.target.value }, this.disableCheck);
  };
  handleModelYear = (event) => {
    this.setState({ modelYear: event.target.value }, this.disableCheck);
  };
  handleFactNumber = (event) => {
    this.setState({ factNumber: event.target.value }, this.disableCheck);
  };
  handleVehicleType = (event) => {
    this.setState({ vehicleType: event.target.value }, this.disableCheck);
  };
  handleEnableAccessories = (event) => {
    this.setState({ enableAccessories: event.target.value }, this.disableCheck);
  };
  handleIsModelE = (event) => {
    this.setState({ isModelE: event.target.value }, this.disableCheck);
  };

  handlePublish = () => {
    const request = {
      catalogId: this.state.catalogId.trim(),
      model: this.state.model.trim(),
      modelYear: this.state.modelYear.trim(),
      vehicleType: this.state.vehicleType,
      isModelE: this.state.isModelE,
      enableAccessories: this.state.enableAccessories,
      factNumber: this.state.factNumber.trim(),
      market: this.props.market,
      user: this.props.user.userId,
    };
    this.props.saveNewCatalog(request);
    this.handleClose();
  };
  disableCheck = () => {
    if (
      this.state.catalogId !== "" &&
      this.state.model !== "" &&
      this.state.modelYear !== "" &&
      this.state.vehicleType !== "" &&
      this.state.isModelE !== "" &&
      this.state.enableAccessories !== "" &&
      this.state.factNumber !== ""
    ) {
      this.setState({ buttonDisabled: false });
    }
  };

  render() {
    return (
      <StyledDialog open={this.props.open}>
        <div className={styles.wrapper}>
          <button className={styles.close} onClick={this.handleClose}>
            <Clear />
          </button>
          <div className={styles.header}>ADD A NEW CATALOG</div>
          <div className={styles.subHeader}>
            Please enter the details to add a new catalog
          </div>
          <div className={styles.textAreaTitle}>CATALOG ID</div>
          <div className={styles.textAreaContainer}>
            <textarea
              value={this.state.catalogId}
              placeholder="CATALOG ID"
              onChange={this.handleCatalogId}
              required={true}
              rows={1}
            />
          </div>

          <div className={styles.textAreaTitle}>FACT NUMBER</div>
          <div className={styles.textAreaContainer}>
            <textarea
              value={this.state.factNumber}
              placeholder="Cologne"
              onChange={this.handleFactNumber}
              required={true}
              rows={1}
            />
          </div>

          <div className={styles.textAreaTitle}>MODEL</div>
          <div className={styles.textAreaContainer}>
            <textarea
              value={this.state.model}
              placeholder="PUMA"
              onChange={this.handleModel}
              required={true}
              rows={1}
            />
          </div>

          <div className={styles.textAreaTitle}>MODEL YEAR</div>
          <div className={styles.textAreaContainer}>
            <textarea
              value={this.state.modelYear}
              placeholder="2024.50"
              onChange={this.handleModelYear}
              required={true}
              rows={1}
            />
          </div>
          {/*{for Vehicle Type}*/}
          <StyledFormControl>
            <div className={styles.radioOptionContainer}>
              <div className={styles.radioTitle}>VEHICLE TYPE</div>
              <div className={styles.radioContainer}>
                <RadioGroup
                  row
                  name="vehicleType"
                  onChange={this.handleVehicleType}
                  value={this.state.vehicleType}
                >
                  <FormControlLabel
                    value="PV"
                    control={<StyledRadio />}
                    label="PV"
                  />
                  <FormControlLabel
                    value="CV"
                    control={<StyledRadio />}
                    label="CV"
                  />
                </RadioGroup>
              </div>
            </div>
          </StyledFormControl>

          {/*{for Vehicle Type}*/}
          <StyledFormControl>
            <div className={styles.radioOptionContainer}>
              <div className={styles.radioTitle}>IS MODEL E</div>
              <div className={styles.radioContainer}>
                <RadioGroup
                  row
                  name="vehicleType"
                  onChange={this.handleIsModelE}
                  value={this.state.isModelE}
                >
                  <FormControlLabel
                    value="true"
                    control={<StyledRadio />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="false"
                    control={<StyledRadio />}
                    label="NO"
                  />
                </RadioGroup>
              </div>
            </div>
          </StyledFormControl>

          {/*{for Vehicle Type}*/}
          <StyledFormControl>
            <div className={styles.radioOptionContainer}>
              <div className={styles.radioTitle}>ENABLE ACCESSORIES</div>
              <div className={styles.radioContainer}>
                <RadioGroup
                  row
                  name="vehicleType"
                  onChange={this.handleEnableAccessories}
                  value={this.state.enableAccessories}
                >
                  <FormControlLabel
                    value="true"
                    control={<StyledRadio />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="false"
                    control={<StyledRadio />}
                    label="NO"
                  />
                </RadioGroup>
              </div>
            </div>
          </StyledFormControl>
          <div className={styles.warning}>
            Please check the details before clicking publish button.
          </div>
          <div className={styles.buttonRowContainer}>
            <Button
              className={styles.cancelledDialogButton}
              onClick={this.handleClose}
            >
              {this.props.t("Announcement.backBtn")}
            </Button>
            <Button
              className={styles.actionBtn}
              onClick={this.handlePublish}
              disabled={this.state.buttonDisabled}
            >
              {this.props.t("Announcement.publishBtn")}
            </Button>
          </div>
        </div>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(AddNewCatalog);
